export default (value, length = 20) =>
	value?.length > length ? `${value.substring(0, length)}...` : value;
